import { useUserRewardsBySeachParamReward } from '@/hooks/useUserRewardsBySearchParamReward';
import { ErrorCard } from '@starsoft/common/components';
import { useInfiniteScroll } from '@starsoft/common/hooks';
import { parseToBigInt } from '@starsoft/common/utils/parsers';
import { AnimatePresence } from 'framer-motion';
import { useMemo } from 'react';
import BonusClaimRewardModalContentRewardCard from './Card';
import styles from './styles.module.scss';

export default function ClaimRewardModalContentRewardCards() {
  const {
    rewardId,
    isLoading,
    fetchNextPage,
    error,
    refetch,
    hasNextPage,
    isFetchingNextPage,
    rewards,
  } = useUserRewardsBySeachParamReward();

  const { ref } = useInfiniteScroll({
    hasMore: hasNextPage,
    isLoading: isFetchingNextPage || isLoading,
    loadMore() {
      fetchNextPage();
    },
  });

  const Cards = useMemo(
    () =>
      rewards?.map(reward => (
        <BonusClaimRewardModalContentRewardCard
          key={`user-reward-card-${reward?.id}`}
          userReward={reward}
          rewardId={parseToBigInt(rewardId) as bigint}
        />
      )),
    [rewards, rewardId],
  );

  const Skeletons = useMemo(
    () =>
      Array.from({ length: 10 })?.map((_, index) => (
        <BonusClaimRewardModalContentRewardCard
          key={`user-reward-card-skeleton-${index}`}
          isLoading
        />
      )),
    [],
  );

  if (error) {
    return (
      <div className={styles.container}>
        <ErrorCard error={error} refetch={refetch} />
      </div>
    );
  }

  return (
    <div className={styles.container} ref={ref}>
      <AnimatePresence>
        {isLoading && Skeletons}
        {Cards}
        {isFetchingNextPage && Skeletons}
      </AnimatePresence>
    </div>
  );
}
